"use strict";

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.is-array");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Lattice = function Lattice(_ref) {
  var children = _ref.children,
      _ref$hideOverflow = _ref.hideOverflow,
      hideOverflow = _ref$hideOverflow === void 0 ? false : _ref$hideOverflow,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className;
  var latticeClasses = ["ltc"];

  if (hideOverflow) {
    latticeClasses.push("ltc--ho");
  }

  if (className) {
    latticeClasses = latticeClasses.concat(Array.isArray(className) ? className : className.split(" "));
  }

  return _react["default"].createElement("div", {
    className: latticeClasses.join(" ")
  }, children);
};

Lattice.propTypes = {
  children: _propTypes["default"].node,
  hideOverflow: _propTypes["default"].bool,
  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)])
};
Lattice.defaultProps = {
  children: null,
  hideOverflow: false,
  className: ""
};
var _default = Lattice;
exports["default"] = _default;